/* Diamond Luxury Rent — comportamenti delle sezioni dlr-* */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Slideshow --- */
  if (!customElements.get('dlr-slideshow')) {
    customElements.define('dlr-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.dlr-slideshow__slide'));
        this.dots = Array.from(this.querySelectorAll('.dlr-slideshow__dot'));
        this.index = 0;
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.start(); }));
        this.start();
      }

      disconnectedCallback() { clearInterval(this.timer); }

      start() {
        clearInterval(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || reduceMotion) return;
        this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), parseInt(this.dataset.speed, 10) || 5000);
      }

      go(i) {
        this.slides[this.index].classList.remove('is-active');
        if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
        this.index = i;
        this.slides[i].classList.add('is-active');
        if (this.dots[i]) this.dots[i].classList.add('is-active');
      }
    });
  }

  /* --- Video che si espande con lo scroll --- */
  if (!customElements.get('dlr-scroll-hero')) {
    customElements.define('dlr-scroll-hero', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.querySelector('[data-scroll-hero]');
        this.bg = this.querySelector('[data-bg]');
        this.media = this.querySelector('[data-media]');
        this.top = this.querySelector('[data-title-top]');
        this.bottom = this.querySelector('[data-title-bottom]');
        this.hint = this.querySelector('[data-hint]');
        this.content = this.querySelector('[data-content]');
        this.yt = this.querySelector('[data-yt]');
        if (reduceMotion) { this.content.classList.add('dlr-vis'); return; }
        this.onScroll = () => { if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => { this.update(); this.ticking = false; }); } };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        var mobile = window.innerWidth < 768;
        var startW = mobile ? 260 : 340;
        var startH = mobile ? 340 : 440;
        var rect = this.hero.getBoundingClientRect();
        var scrollable = this.hero.offsetHeight - window.innerHeight;
        var p = Math.min(Math.max(-rect.top / scrollable, 0), 1);

        var w = startW + p * (window.innerWidth - startW);
        var h = startH + p * (window.innerHeight - startH);
        this.media.style.width = w + 'px';
        this.media.style.height = h + 'px';
        if (this.yt) {
          this.yt.style.width = Math.max(w, h * 16 / 9) + 'px';
          this.yt.style.height = Math.max(h, w * 9 / 16) + 'px';
        }
        this.media.style.borderRadius = 16 * (1 - p) + 'px';
        this.media.style.boxShadow = p < 0.95 ? '0 0 50px rgba(0,0,0,0.4)' : 'none';
        this.media.style.setProperty('--overlay-opacity', 0.3 - p * 0.3);
        this.bg.style.opacity = 1 - p;

        var tx = p * (mobile ? 120 : 80);
        this.top.style.transform = 'translateX(-' + tx + 'vw)';
        this.bottom.style.transform = 'translateX(' + tx + 'vw)';
        this.top.style.opacity = this.bottom.style.opacity = 1 - p * 1.5;
        this.hint.style.opacity = Math.max(0, 1 - p * 3);

        if (p > 0.9) this.content.classList.add('dlr-vis');
      }
    });
  }

  /* --- Comparsa allo scroll --- */
  function initReveal() {
    var items = document.querySelectorAll('.dlr-fade-up:not(.dlr-vis)');
    if (!('IntersectionObserver' in window) || reduceMotion || Shopify.designMode) {
      items.forEach(function (el) { el.classList.add('dlr-vis'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dlr-vis'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* --- Pulsante audio del video hero --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dlr-sound]');
    if (!btn) return;
    var video = btn.closest('.dlr-hero').querySelector('video');
    if (!video) return;
    var on = video.muted;
    video.muted = !on;
    if (on) { video.volume = 1; video.play(); }
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? "Disattiva l'audio" : "Attiva l'audio");
    btn.querySelector('.dlr-sound__label').textContent = on ? 'Audio attivo' : 'Attiva audio';
  });

  window.Shopify = window.Shopify || {};
  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);
})();
